import { makeMonitorRepository } from "../repositories/repositoryBuilders.js";
import { router } from "@foretagsplatsen/widgetjs";
import ErrorResult from "../../models/ErrorResult.js";
import notifier from "../widgets/notifier/notifier.js";
import session from "../session.js";
import sync from "../sync.js";
import userFactory from "../../models/userFactory.js";

function userService() {
	const that = {};

	const authenticatePath = "/External/Authenticate/";
	const loginPath = `${authenticatePath}LegacyLogin`;
	const logoutPath = "/External/SetAuthCookie?abandonSession=true";
	const resetPasswordPath = `${authenticatePath}ResetPassword`;

	that.login = function (spec) {
		const username = spec.username;
		const password = spec.password;
		const onSuccess = spec.onSuccess;
		const onError = spec.onError;

		const loginRepository = makeMonitorRepository({
			route: loginPath,
			antiForgeryToken: session.getAntiForgeryToken(),
		});

		loginRepository
			.save({ model: { username, password }, notify: false })
			.then(handleSuccess(onSuccess), onError);
	};

	that.logout = function (onSuccess, onError) {
		sync.get(logoutPath, {
			success: handleSuccess(onSuccess),
			error: handleError(onError),
		});
	};

	that.resetPassword = function (spec) {
		const resetPasswordRepository = makeMonitorRepository({
			route: resetPasswordPath,
			antiForgeryToken: session.getAntiForgeryToken(),
		});

		const username = spec.username || "";
		const onSuccess = spec.onSuccess || function () {};
		const onError = spec.onError || function () {};

		resetPasswordRepository
			.save({ model: { username }, notify: false })
			.then(onSuccess, onError);
	};

	that.isConsultant = function () {
		return that.currentUser.isConsultant();
	};

	that.getWKLoginUrl = function () {
		let uri = "/external/authenticate/login";
		const returnUrl = router.getRouter().getParameter("ReturnUrl");
		if (returnUrl) {
			uri = uri.concat("?returnUrl=", encodeURIComponent(returnUrl));
		}
		return uri;
	};

	function handleSuccess(onSuccess) {
		return function (data) {
			const user = setUser(data);
			onSuccess?.(user);
		};
	}

	function setUser(data) {
		const user = userFactory.materialize(data);
		session.setCurrentUser(user);
		return user;
	}

	function handleError(onError) {
		return function (xhr) {
			const error = buildError(xhr);
			if (onError) {
				onError(error);
			} else {
				notifier.error(error.toString());
			}
		};
	}

	function buildError(xhr) {
		return new ErrorResult({ jqXHR: xhr });
	}

	return that;
}

// Singleton object exposed only.
export default userService();
